export const nav = {
    permissao: 'hdocs.integracoes:ver',
    section: 'Configuracao',
    title: 'Integracoes',
    icon: 'integration_instructions',
    route: '/integracoes',
    sequence: 14, // ver comentario em modules/categorias/routes.js
};

export default [
    {
        path: '/integracoes',
        name: 'integracoes',
        component: () => import('./pages/IntegracoesPage.vue'),
        meta: { requiresAuth: true, permissao: 'hdocs.integracoes:ver' },
    },
    {
        path: '/integracoes/:id/consultas',
        name: 'integracoes-consultas',
        component: () => import('./pages/ConsultasPage.vue'),
        props: true,
        meta: { requiresAuth: true, permissao: 'hdocs.integracoes:ver' },
    },
];
